import React from 'react';
interface InputFieldValueProps {
 value: InputFieldProps;

 children?: React.ReactNode;
}

interface InputFieldProps {
  url: string;
  title: string;
  className: string;
  childrenClassName?: string;
  
}

const Banner: React.FC<InputFieldValueProps> = ({children,value}) => {
  const { url, childrenClassName, className, title } = value;
  return (

    <div style={{ backgroundImage: `url(${url})`}} 
         className={`${className}`}
    >
        <div className={`banner-title ${childrenClassName}`}>{title}</div>
        {children}
    </div>
  );
};

export default Banner;
